module.exports = {"TXTCLI_More":{"id":"TXTCLI_More","defaultMessage":"Mehr","flags":["TRACK"],"track":"More"}}